import { Button, CircularProgress, SvgIcon, styled } from "@mui/joy";
import React, { useRef, useState } from "react"
import toast from "react-hot-toast";
import { BASE_URL, BLACK, PRIMARY } from "../../appConstants";
import { UUID } from "crypto";
import xlsx_to_json from "../../appFunctions";
import appError from "../../appError";
import axios from "axios";
import { useSelector } from "react-redux";
import { formatDateTime } from "./../../appFunctions"
const VisuallyHiddenInput = styled('input')`
clip: rect(0 0 0 0);
clip-path: inset(50%);
height: 1px;
overflow: hidden;
position: absolute;
bottom: 0;
left: 0;
white-space: nowrap;
width: 1px;
`;

type FileDetailObj = {
    file_id: UUID,
    file_type: string,
    file_name: string,
    created_time_stamp: string,
    updated_time_stamp: string
}

type CrawledCampaignProps = {
    fileDetail: FileDetailObj | undefined,
    fetchFileDetail: () => void
}





type BrandCrawledCampaignObject = {
    campaign_name: string,
    campaign_type: string,
    campaign_id: string,
    external_campaign_id: string,
    platform: string,
}


const CrawledCampaign: React.FC<CrawledCampaignProps> = ({ fileDetail, fetchFileDetail }) => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [loadingUploadExcel, setLoadingUploadExcel] = useState<boolean>(false);
    const { brand_id } = useSelector((state: any) => state.appData);

    const onFileChangeHandler = async (event: React.ChangeEvent<HTMLInputElement>) => {
        if (!(event.target.files && event.target.files.length > 0)) {
            return;
        }



        try {
            setLoadingUploadExcel(true);
            let file = event.target.files[0];
            let brand_crawled_campaign_array: BrandCrawledCampaignObject[] = await xlsx_to_json(file);
            if (!brand_crawled_campaign_array.length) {
                return;
            }

            const campaign_one = brand_crawled_campaign_array[0];
            if (!("campaign_name" in campaign_one)) {
                appError("Please provide campaign_name column.");
                return
            } else if (!("campaign_type" in campaign_one)) {
                appError("Please provide campaign_type column.");
                return
            } else if (!("campaign_id" in campaign_one)) {
                appError("Please provide campaign_id column.");
                return
            } else if (!("external_campaign_id" in campaign_one)) {
                appError("Please provide external_campaign_id column.");
                return
            } else if (!("platform" in campaign_one)) {
                appError("Please provide platform column.");
                return
            }


            for (let i in brand_crawled_campaign_array) {
                let {
                    campaign_name,
                    campaign_type,
                    campaign_id,
                    external_campaign_id,
                    platform
                } = brand_crawled_campaign_array[i];

                campaign_name = campaign_name?.toString().trim();
                campaign_type = campaign_type?.toString().trim();
                campaign_id = campaign_id?.toString().trim();
                external_campaign_id = external_campaign_id?.toString().trim();
                platform = platform?.toString().trim();



                if (!campaign_name) {
                    appError(`Please provide campaign_name on row ${(parseInt(i) + 2)}.`);
                    return;
                } else if (!campaign_type) {
                    appError(`Please provide campaign_type on row ${(parseInt(i) + 2)}.`);
                    return;
                } else if (!campaign_id) {
                    appError(`Please provide campaign_id on row ${(parseInt(i) + 2)}.`);
                    return;
                } else if (!external_campaign_id) {
                    appError(`Please provide external_campaign_id on row ${(parseInt(i) + 2)}.`);
                    return;
                } else if (!platform) {
                    appError(`Please provide platform on row ${(parseInt(i) + 2)}.`);
                    return;
                }

            }


            const token = localStorage.getItem("token");
            const res = await axios.post(`${BASE_URL}onboarding/manual/crawledCampaigns?brand_id=${brand_id}`,
                {
                    file_name: file.name,
                    brand_crawled_campaign_array
                },
                {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });
            // let resObj = res?.data;
            // if (resObj?.status === "success") {
            //     toast.success(resObj?.data?.message);
            // }
            fetchFileDetail();
        } catch (error) {
            appError(error);
        } finally {
            if (fileInputRef.current) {
                fileInputRef.current.value = '';
            }
            setLoadingUploadExcel(false);
        }
    }




    const backgroundImageUrl = `${process.env.PUBLIC_URL}/half_circle.png`

    const divStyle = {
        backgroundImage: `url(${backgroundImageUrl})`,
        backgroundSize: '60% 85px',
        backgroundPosition: 'top left',  // Starts from the top left corner
        backgroundRepeat: 'no-repeat',  // Prevents the image from repeating
    }    


    return (
        <div style={{ border: `1px solid ${BLACK.B_5}`, borderRadius: 16,...divStyle }} className="flex flex-col  p-6 h-full" >
            <div className="flex justify-center items-center mb-10" style={{ height: 52, width: 52, borderRadius: 8, background: "linear-gradient(180deg, #FCCCFF 0%, #75B6FF 52%, #00E6F0 100%)" }} >
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M6.66663 29.3334C5.93329 29.3334 5.30551 29.0723 4.78329 28.5501C4.26107 28.0279 3.99996 27.4001 3.99996 26.6667V11.6334C3.59996 11.389 3.27774 11.0723 3.03329 10.6834C2.78885 10.2945 2.66663 9.84453 2.66663 9.33341V5.33341C2.66663 4.60008 2.92774 3.9723 3.44996 3.45008C3.97218 2.92786 4.59996 2.66675 5.33329 2.66675H26.6666C27.4 2.66675 28.0277 2.92786 28.55 3.45008C29.0722 3.9723 29.3333 4.60008 29.3333 5.33341V9.33341C29.3333 9.84453 29.2111 10.2945 28.9666 10.6834C28.7222 11.0723 28.4 11.389 28 11.6334V26.6667C28 27.4001 27.7388 28.0279 27.2166 28.5501C26.6944 29.0723 26.0666 29.3334 25.3333 29.3334H6.66663ZM6.66663 12.0001V26.6667H25.3333V12.0001H6.66663ZM5.33329 9.33341H26.6666V5.33341H5.33329V9.33341ZM13.3333 18.6667H18.6666C19.0444 18.6667 19.3611 18.539 19.6166 18.2834C19.8722 18.0279 20 17.7112 20 17.3334C20 16.9556 19.8722 16.639 19.6166 16.3834C19.3611 16.1279 19.0444 16.0001 18.6666 16.0001H13.3333C12.9555 16.0001 12.6388 16.1279 12.3833 16.3834C12.1277 16.639 12 16.9556 12 17.3334C12 17.7112 12.1277 18.0279 12.3833 18.2834C12.6388 18.539 12.9555 18.6667 13.3333 18.6667Z" fill="white" />
                </svg>
            </div>

            <div className="mb-3" style={{ fontSize: 18, fontWeight: 600 }} >
                Downloaded Campaign Details
            </div>
            <div style={{ fontSize: 14, fontWeight: 400, color: BLACK.B_40 }} className="mb-6">
                Download the template, fill in your downloaded campaign details, and upload it to integrate your data seamlessly.
            </div>
            <div className="flex items-center mb-6" >
                <Button
                    component="a"
                    size="sm"

                    variant="outlined"
                    startDecorator={

                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="20" viewBox="0 0 18 20" fill="none">
                            <path d="M12.9775 0.0100088C12.935 -0.0374912 11.4037 0.0287588 10.0712 1.47501C8.73875 2.92001 8.94375 4.57751 8.97375 4.62001C9.00375 4.66251 10.8737 4.72876 12.0675 3.04751C13.2612 1.36626 13.02 0.0587588 12.9775 0.0100088ZM17.12 14.6763C17.06 14.5563 14.2137 13.1338 14.4787 10.3988C14.7437 7.66376 16.5725 6.91251 16.6012 6.83126C16.63 6.75001 15.855 5.84376 15.0337 5.38501C14.4306 5.06189 13.7634 4.8766 13.08 4.84251C12.945 4.83876 12.4762 4.72376 11.5125 4.98751C10.8775 5.16126 9.44625 5.72376 9.0525 5.74626C8.6575 5.76876 7.4825 5.09376 6.21875 4.91501C5.41 4.75876 4.5525 5.07876 3.93875 5.32501C3.32625 5.57001 2.16125 6.26751 1.34625 8.12126C0.531249 9.97376 0.957499 12.9088 1.2625 13.8213C1.5675 14.7338 2.04375 16.2263 2.85375 17.3163C3.57375 18.5463 4.52875 19.4 4.9275 19.69C5.32625 19.98 6.45125 20.1725 7.23125 19.7738C7.85875 19.3888 8.99125 19.1675 9.43875 19.1838C9.885 19.2 10.765 19.3763 11.6662 19.8575C12.38 20.1038 13.055 20.0013 13.7312 19.7263C14.4075 19.45 15.3862 18.4025 16.5287 16.2788C16.9621 15.2913 17.1592 14.7571 17.12 14.6763Z" fill="#1886FE" />
                            <path d="M12.9775 0.0100088C12.935 -0.0374912 11.4037 0.0287588 10.0712 1.47501C8.73875 2.92001 8.94375 4.57751 8.97375 4.62001C9.00375 4.66251 10.8737 4.72876 12.0675 3.04751C13.2612 1.36626 13.02 0.0587588 12.9775 0.0100088ZM17.12 14.6763C17.06 14.5563 14.2137 13.1338 14.4787 10.3988C14.7437 7.66376 16.5725 6.91251 16.6012 6.83126C16.63 6.75001 15.855 5.84376 15.0337 5.38501C14.4306 5.06189 13.7634 4.8766 13.08 4.84251C12.945 4.83876 12.4762 4.72376 11.5125 4.98751C10.8775 5.16126 9.44625 5.72376 9.0525 5.74626C8.6575 5.76876 7.4825 5.09376 6.21875 4.91501C5.41 4.75876 4.5525 5.07876 3.93875 5.32501C3.32625 5.57001 2.16125 6.26751 1.34625 8.12126C0.531249 9.97376 0.957499 12.9088 1.2625 13.8213C1.5675 14.7338 2.04375 16.2263 2.85375 17.3163C3.57375 18.5463 4.52875 19.4 4.9275 19.69C5.32625 19.98 6.45125 20.1725 7.23125 19.7738C7.85875 19.3888 8.99125 19.1675 9.43875 19.1838C9.885 19.2 10.765 19.3763 11.6662 19.8575C12.38 20.1038 13.055 20.0013 13.7312 19.7263C14.4075 19.45 15.3862 18.4025 16.5287 16.2788C16.9621 15.2913 17.1592 14.7571 17.12 14.6763Z" fill="#1886FE" />
                        </svg>

                    }
                    sx={{
                        borderRadius: 8,
                        height: 40,
                        width: 146,
                        marginRight: "16px",

                    }}
                    //href={`${FLASK_EXCEL_API_URL}onBoardingExcels?brand_id=${brandId}&module=product`}
                    onClick={() => {
                        toast.loading("Please wait download will start 👆 soon.", {
                            duration: 3000
                        })
                    }}
                > For macOS</Button>


                <Button
                    component="a"
                    size="sm"

                    variant="outlined"
                    startDecorator={
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M12.5144 13.4275C11.4319 13.2994 10.6256 12.86 9.88187 12.365L9.53312 12.5388L7.92187 18.1163C8.68249 18.6194 9.73749 19.1832 10.8481 19.3125C12.5269 19.5075 14.3231 18.8475 14.8419 18.5657L16.4781 12.9032L16.1281 12.7282C16.1281 12.7282 14.4969 13.6607 12.5156 13.4282L12.5144 13.4275ZM9.01437 11.765C8.22312 11.2213 7.40374 10.7338 6.28062 10.6307C6.08822 10.6127 5.8951 10.6037 5.70187 10.6038C3.82062 10.6038 2.60937 11.4457 2.60937 11.4457L1.00624 16.9938L1.33562 17.17C2.32428 16.6912 3.42097 16.4792 4.51687 16.555C5.55749 16.6257 6.34187 17.0425 7.08999 17.5113L7.40687 17.3488L9.01562 11.7657L9.01437 11.765ZM6.37562 10.0588C7.41624 10.13 8.20187 10.5463 8.94937 11.0169L9.26812 10.8544L10.875 5.26879C10.0812 4.72504 9.26249 4.23629 8.13937 4.13441C7.94739 4.11659 7.75467 4.10783 7.56187 4.10816C5.67937 4.10816 4.46812 4.95004 4.46812 4.95004L2.86437 10.4988L3.19312 10.675C4.18198 10.1967 5.27842 9.9843 6.37437 10.0588H6.37562ZM17.9875 6.23129C17.9875 6.23254 16.3562 7.16441 14.375 6.93129C13.2912 6.80379 12.4856 6.36441 11.7419 5.86879L11.3919 6.04379L9.78187 11.6207C10.5419 12.1225 11.5987 12.6894 12.7069 12.8175C14.3869 13.0125 16.1819 12.3519 16.7025 12.0694L18.3369 6.40816L17.9869 6.23316L17.9875 6.23129Z" fill="#1886FE"/>
                        </svg>
                    }
                    sx={{
                        borderRadius: 8,
                        height: 40,
                        width: 146,
                        marginRight: "16px",

                    }}
                    //href={`${FLASK_EXCEL_API_URL}onBoardingExcels?brand_id=${brandId}&module=product`}
                    onClick={() => {
                        toast.loading("Please wait download will start 👆 soon.", {
                            duration: 3000
                        })
                    }}
                > For Windows</Button>
                {/* <input type="file" onChange={onFileChangeHandler} /> */}
                <Button
                    // loading={loadingUploadExcel}
                    component="label"
                    role={undefined}
                    tabIndex={-1}
                    variant="outlined"

                    size="sm"
                    sx={{
                        color: PRIMARY.P_BLue,
                        height: 40,
                        borderColor: PRIMARY.P_BLue,
                        borderRadius: "8px",
                        width: 146
                    }}
                    startDecorator={
                        <SvgIcon>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth={1.5}
                                stroke="currentColor"
                            >
                                <path
                                    color={PRIMARY.P_BLue}
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
                                />
                            </svg>
                        </SvgIcon>
                    }
                >
                    Upload Excel
                    <VisuallyHiddenInput
                        ref={fileInputRef}
                        onChange={onFileChangeHandler}
                        type="file" />
                </Button>

            </div>
            <div className="flex flex-row justify-between items-center" >
                <div>
                    {
                        fileDetail?.file_id && (
                            <div className="flex items-center" >
                                <div className="mr-2" >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                                        <path d="M19.5001 26C19.5001 26.2652 19.3947 26.5196 19.2072 26.7071C19.0196 26.8946 18.7653 27 18.5001 27H15.0001C14.7348 27 14.4805 26.8946 14.293 26.7071C14.1054 26.5196 14.0001 26.2652 14.0001 26V19C14.0001 18.7348 14.1054 18.4804 14.293 18.2929C14.4805 18.1054 14.7348 18 15.0001 18C15.2653 18 15.5196 18.1054 15.7072 18.2929C15.8947 18.4804 16.0001 18.7348 16.0001 19V25H18.5001C18.7653 25 19.0196 25.1054 19.2072 25.2929C19.3947 25.4804 19.5001 25.7348 19.5001 26ZM11.5813 18.1863C11.4744 18.1099 11.3536 18.0554 11.2257 18.0258C11.0977 17.9961 10.9652 17.992 10.8357 18.0136C10.7061 18.0352 10.5821 18.0821 10.4707 18.1516C10.3593 18.2211 10.2626 18.3119 10.1863 18.4188L8.50006 20.78L6.81381 18.4188C6.7402 18.3055 6.6444 18.2083 6.53221 18.1331C6.42001 18.0579 6.29374 18.0062 6.161 17.9811C6.02827 17.956 5.89184 17.9581 5.75993 17.9872C5.62802 18.0163 5.50337 18.0718 5.39351 18.1504C5.28365 18.229 5.19085 18.329 5.12071 18.4445C5.05057 18.5599 5.00455 18.6884 4.98542 18.8221C4.96629 18.9558 4.97445 19.092 5.00941 19.2225C5.04436 19.353 5.10539 19.475 5.18881 19.5812L7.27131 22.5L5.18631 25.4188C5.04599 25.6346 4.99436 25.8963 5.04217 26.1494C5.08997 26.4024 5.23353 26.6272 5.44295 26.777C5.65237 26.9268 5.91151 26.9901 6.1664 26.9536C6.42129 26.9172 6.6523 26.7838 6.81131 26.5812L8.50006 24.22L10.1863 26.5812C10.3453 26.7838 10.5763 26.9172 10.8312 26.9536C11.0861 26.9901 11.3453 26.9268 11.5547 26.777C11.7641 26.6272 11.9076 26.4024 11.9555 26.1494C12.0033 25.8963 11.9516 25.6346 11.8113 25.4188L9.72881 22.5L11.8138 19.5812C11.8901 19.4744 11.9447 19.3535 11.9743 19.2256C12.0039 19.0977 12.0081 18.9651 11.9865 18.8356C11.9649 18.7061 11.918 18.582 11.8485 18.4706C11.779 18.3592 11.6882 18.2626 11.5813 18.1863ZM23.9488 21.4137C23.4488 21.2687 22.9313 21.12 22.6426 20.9338C22.4863 20.8312 22.4888 20.8088 22.5026 20.6963C22.5044 20.6054 22.5281 20.5162 22.5716 20.4364C22.6151 20.3566 22.6772 20.2883 22.7526 20.2375C23.3276 19.8475 24.6701 20.0225 25.2301 20.1675C25.4867 20.235 25.7595 20.1977 25.9887 20.064C26.2178 19.9303 26.3845 19.711 26.4519 19.4544C26.5194 19.1978 26.4822 18.9249 26.3484 18.6957C26.2147 18.4666 25.9954 18.3 25.7388 18.2325C25.4751 18.1637 23.1138 17.58 21.6351 18.5775C21.3232 18.7882 21.0615 19.0647 20.8682 19.3876C20.6749 19.7105 20.5547 20.0719 20.5163 20.4463C20.2663 22.4313 22.2226 22.9975 23.3913 23.335C24.8988 23.7712 25.0313 23.95 24.9888 24.2838C24.9501 24.585 24.8313 24.7 24.7201 24.775C24.1451 25.1575 22.8251 24.9688 22.2776 24.8188C22.0215 24.7476 21.7476 24.7812 21.5162 24.912C21.4017 24.9768 21.301 25.0635 21.2199 25.1671C21.1389 25.2708 21.079 25.3894 21.0438 25.5163C21.0086 25.6431 20.9987 25.7756 21.0147 25.9062C21.0307 26.0368 21.0723 26.163 21.137 26.2776C21.2678 26.509 21.4852 26.6789 21.7413 26.75C22.3611 26.9133 22.9991 26.9973 23.6401 27C24.3676 27 25.1776 26.875 25.8263 26.4425C26.1463 26.2297 26.4152 25.9485 26.6137 25.6194C26.8121 25.2902 26.9351 24.9211 26.9738 24.5387C27.2501 22.375 25.1851 21.7712 23.9488 21.4137ZM5.00006 14V5C5.00006 4.46957 5.21077 3.96086 5.58585 3.58579C5.96092 3.21071 6.46963 3 7.00006 3H19.0001C19.1314 2.9999 19.2615 3.02568 19.3829 3.07586C19.5043 3.12605 19.6146 3.19967 19.7076 3.2925L26.7076 10.2925C26.8004 10.3854 26.874 10.4958 26.9242 10.6172C26.9744 10.7385 27.0002 10.8686 27.0001 11V14C27.0001 14.2652 26.8947 14.5196 26.7072 14.7071C26.5196 14.8946 26.2653 15 26.0001 15C25.7348 15 25.4805 14.8946 25.293 14.7071C25.1054 14.5196 25.0001 14.2652 25.0001 14V12H19.0001C18.7348 12 18.4805 11.8946 18.293 11.7071C18.1054 11.5196 18.0001 11.2652 18.0001 11V5H7.00006V14C7.00006 14.2652 6.8947 14.5196 6.70717 14.7071C6.51963 14.8946 6.26528 15 6.00006 15C5.73484 15 5.48049 14.8946 5.29295 14.7071C5.10542 14.5196 5.00006 14.2652 5.00006 14ZM20.0001 10H23.5851L20.0001 6.41375V10Z" fill="#1C1C1C" fill-opacity="0.4" />
                                    </svg>
                                </div>
                                <div className="flex  flex-col" >
                                    <div className="mb-1" style={{ fontSize: 12, fontWeight: 500, color: BLACK.B_40 }} >{fileDetail?.file_name}</div>
                                    {
                                        fileDetail?.updated_time_stamp ? (
                                            <div style={{ fontSize: 10, fontWeight: 500, color: BLACK.B_20 }} className="flex items-center" > {formatDateTime(fileDetail?.updated_time_stamp)[0]} <svg className="mx-2" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                                                <circle cx="2" cy="2" r="2" fill="#B8B8B8" />
                                            </svg>  {formatDateTime(fileDetail?.updated_time_stamp)[1]}
                                            </div>
                                        ) : (
                                            <div style={{ fontSize: 10, fontWeight: 500, color: BLACK.B_20 }} className="flex items-center" > {formatDateTime(fileDetail?.created_time_stamp)[0]} <svg className="mx-2" xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
                                                <circle cx="2" cy="2" r="2" fill="#B8B8B8" />
                                            </svg>  {formatDateTime(fileDetail?.created_time_stamp)[1]}
                                            </div>
                                        )
                                    }

                                </div>
                            </div>
                        )
                    }
                </div>
                <div className="flex justify-center" >
                    {
                        loadingUploadExcel && <CircularProgress size="sm" />
                    }
                    {
                        fileDetail?.file_id && !loadingUploadExcel && (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M10.5808 14.1463L8.25775 11.823C8.11925 11.6847 7.94517 11.6138 7.7355 11.6105C7.526 11.6073 7.34875 11.6782 7.20375 11.823C7.05892 11.968 6.9865 12.1437 6.9865 12.35C6.9865 12.5563 7.05892 12.732 7.20375 12.877L9.948 15.6212C10.1288 15.8019 10.3398 15.8923 10.5808 15.8923C10.8218 15.8923 11.0327 15.8019 11.2135 15.6212L16.777 10.0578C16.9153 9.91925 16.9862 9.74517 16.9895 9.5355C16.9927 9.326 16.9218 9.14875 16.777 9.00375C16.632 8.85892 16.4563 8.7865 16.25 8.7865C16.0437 8.7865 15.868 8.85892 15.723 9.00375L10.5808 14.1463ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill="#007F5F" />
                        </svg>
                        )
                    }
                </div>
            </div>
        </div>
    )
}

export default CrawledCampaign;